export default "__VITE_ASSET__ea4fdf53__"